import { createFileRoute, redirect } from '@tanstack/react-router'

// Корень хаба — сразу в справочник компаний (дашбордов у хаба нет).
export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ to: '/companies' })
  },
})
